import * as numbers from './numbers';
import * as letters from './letters';
import * as colors from './colors';
import test from './test-game.json';

export default {
  ...numbers,
  ...letters,
  ...colors,
  test
};
